import * as React from 'react';
import * as classnames from 'classnames';
import Select from 'react-select';

import {
    AudienceRule as IAudienceRule,
    AudienceRuleOption
} from '@nexxt/common/types';
import AudienceRuleHeader from '../AudienceRuleHeader';
import { MAPPING_TARGETTING_OPTIONS } from '../../../../../constants/audience';
import { errorObject } from '../../AudienceRule';
import * as _ from 'lodash';
import { BUILT_IN_OPTION_VALUE } from '@nexxt/common/constants';

interface SingleAudienceRuleProps {
    audienceRule: IAudienceRule;
    audienceRuleOptions: AudienceRuleOption[];
    halfWidth: boolean;
    toggle: boolean;
    isMenuOpen: boolean;
    isDisabled: boolean;
    hasInvalid: boolean;
    errorObject: errorObject;
    health?: any;
    setIsMenuOpen: () => void;
    onEdit: (editingQuestion) => void;
    onDelete: () => void;
    onChangeFilterToggle: () => void;
    onChangeTargettingOption: (
        response: { label: string; value: string } | boolean,
        isMultipleAnswer: boolean,
        isBuiltIn: boolean,
        index: number
    ) => void;
    onChangeSampleSize: (
        id: number,
        index: number,
        event: React.ChangeEvent<HTMLInputElement>
    ) => void;
    onClickSelectAll: (selectAll: boolean, isMultipleAns: boolean) => void;
    disableByFieldName: (keyName?: string) => boolean;
}

const SingleAudienceRule = ({
    audienceRule,
    audienceRuleOptions,
    halfWidth,
    toggle,
    isMenuOpen,
    isDisabled,
    hasInvalid,
    errorObject,
    health,
    setIsMenuOpen,
    onChangeTargettingOption,
    onChangeSampleSize,
    onChangeFilterToggle,
    onEdit,
    onDelete,
    onClickSelectAll,
    disableByFieldName
}: SingleAudienceRuleProps): JSX.Element => {
    const tdAlign = !toggle ? 'right' : 'left';
    const selectDropdownStyles = {
        control: (base) => ({
            ...base,
            background: '#F2F2F2'
        })
    };
    const checkSelectAll = () =>
        audienceRule.audienceRuleOptions
            ?.filter(
                (audienceRuleOption) =>
                    audienceRuleOption.value !== BUILT_IN_OPTION_VALUE
            )
            .some((opt) => opt.mode?.terminateEnabled);
    const renderOptions = (options) => {
        return options.map((option) => {
            const index = audienceRule.audienceRuleOptions.findIndex(
                (audienceOption) => _.isEqual(audienceOption, option)
            );
            return (
                <tr className="option-row" key={index}>
                    <td>{option.label}</td>
                    <td align={tdAlign}>
                        <div className="dropdown-container--t-option">
                            <Select
                                options={MAPPING_TARGETTING_OPTIONS}
                                value={
                                    option.mode?.terminateEnabled
                                        ? MAPPING_TARGETTING_OPTIONS[1]
                                        : MAPPING_TARGETTING_OPTIONS[0]
                                }
                                onChange={(response) => {
                                    onChangeTargettingOption(
                                        response,
                                        false,
                                        false,
                                        index
                                    );
                                }}
                                isDisabled={isDisabled}
                                styles={selectDropdownStyles}
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                                isSearchable={false}
                            />
                        </div>
                    </td>
                    {toggle && !option.mode.terminateEnabled && (
                        <td>
                            <input
                                type="number"
                                name="max"
                                min={0}
                                className={`form-group__control ${
                                    hasInvalid &&
                                    errorObject.optionKeys[index] &&
                                    'error-border'
                                }`}
                                value={option.sampleSize.max || ''}
                                onChange={(e) =>
                                    onChangeSampleSize(option.id, index, e)
                                }
                                disabled={
                                    isDisabled || option.mode.terminateEnabled
                                }
                                placeholder={
                                    hasInvalid &&
                                    errorObject.optionKeys[index] &&
                                    'Enter Quota'
                                }
                            />
                        </td>
                    )}
                </tr>
            );
        });
    };
    return (
        <>
            <AudienceRuleHeader
                audienceRule={audienceRule}
                toggle={toggle}
                isDisabled={isDisabled}
                quotaEnabled={true}
                isMenuOpen={isMenuOpen}
                setIsMenuOpen={setIsMenuOpen}
                onEdit={onEdit}
                onDelete={onDelete}
                onChangeFilterToggle={onChangeFilterToggle}
                isBuiltIn={false}
                isHalfWidth={halfWidth}
                hasInvalid={hasInvalid}
                errorObject={errorObject}
                disableByFieldName={disableByFieldName}
                health={health}
            />
            {halfWidth ? (
                <table>
                    <colgroup>
                        {!toggle ? (
                            <>
                                <col span={1} className="col-2" />
                                <col span={1} className="col-2" />
                            </>
                        ) : (
                            <>
                                <col span={1} className="col-3" />
                                <col span={1} className="col-3" />
                                <col span={1} className="col-3" />
                            </>
                        )}
                    </colgroup>
                    <tbody>
                        <tr className="content-header">
                            <td>
                                Answer{' '}
                                <span
                                    className={classnames('clk', {
                                        disabled: isDisabled
                                    })}
                                    onClick={() => {
                                        if (!isDisabled) {
                                            const check = checkSelectAll();
                                            onClickSelectAll(check, false);
                                        }
                                    }}
                                >
                                    {checkSelectAll()
                                        ? 'Qualify All'
                                        : 'Disqualify All'}
                                </span>
                            </td>
                            <td align={tdAlign}>Screening Logic</td>
                            {toggle && <td>Quota</td>}
                        </tr>
                        {renderOptions(audienceRuleOptions)}
                    </tbody>
                </table>
            ) : (
                <div className="wide-screener-container">
                    {audienceRuleOptions.map((options, ind) => (
                        <table
                            style={{
                                marginRight: ind === 0 && '50px'
                            }}
                            key={
                                ind === 0
                                    ? 'leftColumn-options'
                                    : 'rightColumn-options'
                            }
                        >
                            <colgroup>
                                {!toggle ? (
                                    <>
                                        <col span={1} className="col-2" />
                                        <col span={1} className="col-2" />
                                    </>
                                ) : (
                                    <>
                                        <col span={1} className="col-3" />
                                        <col span={1} className="col-3" />
                                        <col span={1} className="col-3" />
                                    </>
                                )}
                            </colgroup>
                            <tbody>
                                <tr className="content-header">
                                    <td>
                                        Answer{' '}
                                        <span
                                            className="clk"
                                            onClick={() => {
                                                if (!isDisabled) {
                                                    const check =
                                                        checkSelectAll();
                                                    onClickSelectAll(
                                                        check,
                                                        false
                                                    );
                                                }
                                            }}
                                        >
                                            {checkSelectAll()
                                                ? 'Qualify All'
                                                : 'Disqualify All'}
                                        </span>
                                    </td>
                                    <td align={tdAlign}>Screening Logic</td>
                                    {toggle && <td>Quota</td>}
                                </tr>
                                {renderOptions(options)}
                            </tbody>
                        </table>
                    ))}
                </div>
            )}
        </>
    );
};

export default SingleAudienceRule;
